export default "__VITE_ASSET__BEurB8Al__"